module.exports = __webpack_public_path__ + "static/nikelogo-b3f010c0492380630bc8072af49832be.png";